export default "__VITE_ASSET__DGdraazx__"